import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { updateVoucher, getVoucher } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";

class EditVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchertitle: "",
      vouchertitleError: null,
      description: "",
      descriptionError: null,
      price: "",
      priceError: "",
      background_color: "",
      isSubmitted: false,
      errormessages: [],
      voucherId: "",
      _notificationSystem: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Voucher</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });
    setTimeout(() => {
      this.props.history.push("/admin/vouchers");
    }, 3000);
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var voucherId = localStorage.getItem("vch_ID");

    getVoucher(obj, voucherId).then((res) => {
      var data = res.data;
      this.setState({
        price: data.price,
        vouchertitle: data.title,
        background_color: data.background_color,
        description: data.description,
        voucherId: voucherId,
      });
    });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    if (this.state.isSubmitted) {
      this.validate(name, value);
    }

    if (name == "price") {
      const re = /^\d*\.?\d*$/;
      if (re.test(value) == true) {
        this.setState({
          [name]: value,
        });
      }
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  validate = (name, value) => {
    console.log(name, value);
    if (name == "vouchertitle") {
      if (value == "" || value == null) {
        this.setState({
          vouchertitleError: (
            <small className="text-danger">Voucher title is required.</small>
          ),
        });
      } else {
        this.setState({
          vouchertitleError: "",
        });
      }
    }

    if (name == "price") {
      if (value == "" || value == null) {
        this.setState({
          priceError: <small className="text-danger">Price is required.</small>,
        });
      } else {
        this.setState({
          priceError: "",
        });
      }
    }
  };

  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    var titleError = null;
    var priceError = null;

    if (this.state.vouchertitle.length == 0) {
      error = true;
      titleError = (
        <small className="text-danger">Voucher title is required.</small>
      );
    } else {
      titleError = null;
    }

    if (this.state.price == "") {
      error = true;
      priceError = <small className="text-danger">Price is required.</small>;
    } else {
      priceError = null;
    }

    this.setState({
      vouchertitleError: titleError,
      priceError: priceError,
      isSubmitted: true,
    });

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      updateVoucher(
        obj,
        this.state.voucherId,
        this.state.vouchertitle,
        this.state.description,
        this.state.price,
        this.state.background_color
      )
        .then((res) => {
          console.log(res);
          if (res.success === false) {
            this.handleNetworkError("bl");
          } else if (res.success === true) {
            this.handleSuccess("bl");
            localStorage.removeItem("vch_ID");
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  };

  setColor = (colors) => {
    this.setState({
      background_color: colors.hex,
    });
  };

  render() {
    const errormessages = this.state.errormessages;

    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel>Voucher Title</ControlLabel>
                      <FormControl
                        name="vouchertitle"
                        value={this.state.vouchertitle}
                        onChange={(event) => {
                          this.onChange(event);
                        }}
                        placeholder="Enter Voucher Title"
                        type="text"
                      />
                      {this.state.vouchertitleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Description</ControlLabel>
                      <FormControl
                        name="description"
                        value={this.state.description}
                        onChange={(event) => {
                          this.onChange(event);
                        }}
                        placeholder="Enter Description"
                        type="text"
                      />
                      {this.state.descriptionError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Price</ControlLabel>
                      <FormControl
                        name="price"
                        value={this.state.price}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.onChange(event);
                        }}
                        placeholder="Enter Price"
                        type="text"
                      />
                      {this.state.priceError}
                    </FormGroup>

                    <FormGroup className="backgroundcolorinput">
                      <ControlLabel>Background Color</ControlLabel>
                      <InputColor
                        initialValue={this.state.background_color}
                        onChange={this.setColor}
                        placement="right"
                      />
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EditVoucher;
